import { getSignDocumentDownloadLink } from "@/Services/TherapyApi/SignDocuments";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import { hasValue } from "@/Utils/Objects";
import { isValidString } from "@/Utils/String";

async function GetDownloadLinkActionHandler(uuid: string): Promise<string | undefined> {
  const resp = await getSignDocumentDownloadLink(uuid).catch(() => undefined);

  if (isApiError(resp) || !hasValue(resp) || !isValidString(resp.signed_url)) {
    return undefined;
  }

  return resp.signed_url;
}

export default GetDownloadLinkActionHandler;
